import React, { useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import SEO from "../components/common/SEO";
import GuideSection from "../components/guides/GuideSection";
import UsingToolGuide from "../components/guides/UsingToolGuide";
import ReadingChartsGuide from "../components/guides/ReadingChartsGuide";
import ReadingPatternsGuide from "../components/guides/ReadingPatternsGuide";
import ChartBasicsGuide from "../components/guides/ChartBasicsGuide";
import PatternBasicsGuide from "../components/guides/PatternBasicsGuide";
import ConvertingGuide from "../components/guides/ConvertingGuide";
import StitchGuide from "../components/guides/StitchGuide";
import TroubleshootingGuide from "../components/guides/TroubleshootingGuide";
import "./GuidesPage.css";

export default function GuidesPage() {
  const [expanded, setExpanded] = useState("");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const sections = [
    {
      id: "using-tool",
      title: "Using Loops & Purls",
      content: <UsingToolGuide />,
    },
    {
      id: "reading-charts",
      title: "Reading Knitting Charts",
      content: <ReadingChartsGuide />,
    },
    {
      id: "reading-patterns",
      title: "Reading Written Patterns",
      content: <ReadingPatternsGuide />,
    },
    {
      id: "chart-basics",
      title: "Chart Basics",
      content: <ChartBasicsGuide />,
    },
    {
      id: "pattern-basics",
      title: "Pattern Basics",
      content: <PatternBasicsGuide />,
    },
    {
      id: "converting",
      title: "Converting Between Formats",
      content: <ConvertingGuide />,
    },
    {
      id: "stitch-guide",
      title: "Stitch Guide",
      content: <StitchGuide />,
    },
    {
      id: "troubleshooting",
      title: "Troubleshooting",
      content: <TroubleshootingGuide />,
    },
  ];

  return (
    <>
      <SEO
        title="Guides"
        description="Comprehensive guides for knitting charts, patterns, and using Loops & Purls. Learn to read charts, understand written patterns, master knitting techniques, and get the most out of our chart maker tool."
        keywords="knitting guides, how to read knitting charts, knitting patterns, chart reading, pattern reading, knitting techniques, stitch guide, knitting tutorial"
      />
      <Box component="main" className="fade-in-up">
        <Container maxWidth="lg" className="guides-container">
          {/* Header */}
          <Box className="center mb-4 mt-4">
            <Typography variant="h2" color="primary">
              Knitting Guides
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" className="mt-1">
              Everything you need to know about knitting charts, patterns, and using Loops & Purls
            </Typography>
            <Box component="hr" className="hr-accent" aria-hidden="true" />
          </Box>

          {/* Accordion Sections */}
          <Box className="guides-accordion-container">
            {sections.map((section) => (
              <GuideSection
                key={section.id}
                id={section.id}
                title={section.title}
                expanded={expanded}
                onChange={handleChange}
              >
                {section.content}
              </GuideSection>
            ))}
          </Box>
        </Container>
      </Box>
    </>
  );
}
